module.exports = __webpack_public_path__ + "img/1-4.43b0cc08.svg";